export default [{
        cityPath: 'albuquerque-nm/',
        city: 'Albuquerque'
    }, {
        cityPath: 'atlanta-ga/',
        city: 'Atlanta'
    }, {
        cityPath: 'austin-tx/',
        city: 'Austin'
    }, {
        cityPath: 'boston-ma/',
        city: 'Boston'
    }, {
        cityPath: 'charleston-sc/',
        city: 'Charleston'
    }, {
        cityPath: 'charlotte-nc/',
        city: 'Charlotte'
    }, {
        cityPath: 'chicago-il/',
        city: 'Chicago'
    }, {
        cityPath: 'dallas-tx/',
        city: 'Dallas'
    }, {
        cityPath: 'denver-co/',
        city: 'Denver'
    }, {
        cityPath: 'houston-tx/',
        city: 'Houston'
    }, {
        cityPath: 'irvine-ca/',
        city: 'Irvine'
    }, {
        cityPath: 'las-vegas-nv/',
        city: 'Las Vegas'
    }, {
        cityPath: 'los-angeles-ca/',
        city: 'Los Angeles'
    }, {
        cityPath: 'manhattan-ny/',
        city: 'Manhattan'
    }, {
        cityPath: 'miami-fl/',
        city: 'Miami'
    }, {
        cityPath: 'nashville-tn/',
        city: 'Nashville'
    }, {
        cityPath: 'new-york-ny/',
        city: 'New York'
    }, {
        cityPath: 'orlando-fl/',
        city: 'Orlando'
    }, {
        cityPath: 'phoenix-az/',
        city: 'Phoenix'
    }, {
        cityPath: 'portland-or/',
        city: 'Portland'
    }, {
        cityPath: 'sacramento-ca/',
        city: 'Sacramento'
    }, {
        cityPath: 'san-antonio-tx/',
        city: 'San Antonio'
    }, {
        cityPath: 'san-diego-ca/',
        city: 'San Diego'
    }, {
        cityPath: 'san-francisco-ca/',
        city: 'San Francisco'
    }, {
        cityPath: 'san-jose-ca/',
        city: 'San Jose'
    }, {
        cityPath: 'scottsdale-az/',
        city: 'Scottsdale'
    }, {
        cityPath: 'seattle-wa/',
        city: 'Seattle'
    }, {
        cityPath: 'tampa-fl/',
        city: 'Tampa '
    }, {
        cityPath: 'tucson-az/',
        city: 'Tucson'
    }, {
        cityPath: 'virginia-beach-va/',
        city: 'Virginia Beach'
}];
